/* eslint-disable array-callback-return */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import {
  useAddRoleAction,
  useGetAllRoleList,
  useGetMicroserviceStatusList,
  useUpdateRoleAction,
} from "../../../hooks";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  Stack,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  BaseModal,
  BaseModalProps,
  InputControl,
  SwitchControl,
} from "../../molecules";
import { Button } from "../../atoms";
import { useForm, Controller } from "react-hook-form";
import { useMemo, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  serviceManagementAddFormSchema,
  ServiceManagementAddFormSchemaFormValuesType,
  serviceManagementAddInitialValues,
} from "./_formTypes";

export type ServiceManagementAddModalProps = BaseModalProps & {
  title?: string;
  serviceManagement?: any;
};

export const ServiceManagementAddModal = ({
  onClose,
  isOpen,
  serviceManagement,
  title = "Servis Yönetimi",
}: ServiceManagementAddModalProps) => {
  const { control, reset, handleSubmit } =
    useForm<ServiceManagementAddFormSchemaFormValuesType>({
      resolver: zodResolver(serviceManagementAddFormSchema),
      defaultValues: serviceManagementAddInitialValues,
    });
  const [selectedRoleIds, setSelectedRoleIds] = useState([] as any);
  const [selectedRoleIdsObject, setSelectedRoleIdsObject] = useState([] as any);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [selectAll, setSelectAll] = useState(false);
  const { data: rawRoleList } = useGetAllRoleList("ACTIVE")
  const { data: rawMicroserviceList } = useGetMicroserviceStatusList({});
  const { mutate: addRoleAction } = useAddRoleAction();
  const { mutate: updateRoleAction } = useUpdateRoleAction();
  const setSnackbar = useSetSnackBar();
  const [tableData, setTableData] = useState();

  const microServiceOptions = useMemo(() => {
    return rawMicroserviceList?.data?.map(
      (microservice: { value: string; key: string }) => ({
        label: microservice?.value,
        value: microservice?.key,
      })
    ) || [];
  }, [rawMicroserviceList?.data]);


  const roleList = useMemo(() => {
    const list = Array.isArray(rawRoleList?.data)
      ? rawRoleList.data.map((menu: { name: string; id: number }) => {
        return {
          label: menu.name,
          value: `${menu.id}`,
        };
      })
      : [];

    return [{ label: "Hepsini Seç", value: "all" }, ...list];
  }, [rawRoleList?.data]);

  useEffect(() => {
    if (serviceManagement && JSON.stringify(serviceManagement) !== "{}") {
      reset({
        microServiceName: serviceManagement.microServiceName,
        controllerName: serviceManagement.controllerName,
        actionName: serviceManagement.actionName,
        canCall: serviceManagement.canCall,
      });

      const matchingRoles = roleList.filter(role => role.value === serviceManagement.roleId.toString());
      setSelectedRoleIds(matchingRoles);
      setSelectedRoleIdsObject(matchingRoles);
    }
  }, [reset, serviceManagement, roleList]);

  const onSubmit = (data: ServiceManagementAddFormSchemaFormValuesType) => {
    const request = {
      ...data,
      roleId: selectedRoleIds,
    };

    if (serviceManagement && serviceManagement?.id > 0) {
      updateRoleAction(
        { ...data, id: serviceManagement.id, roleId: Number(selectedRoleIds[0]?.value) || 0, },
        {
          onSuccess(data) {
            if (data.isSuccess) {
              setTableData(data.data)
              onClose();
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                isOpen: true,
                description: data.message,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: "İşlem sırasında bir hata oluştu",
            });
          },
        }
      );
    } else {
      addRoleAction(request, {
        onSuccess(data) {
          if (data.isSuccess) {
            setTableData(data.data)
            onClose();
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }
  };




  useEffect(() => {
    if (isOpen === false) {
      reset({});
    }
  }, [isOpen]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  return (
    <BaseModal onClose={onClose} title={title} isOpen={isOpen}>
      <Stack flex={1} p={4}>
        {/* !!! --- FORM --- !!! */}
        <Stack spacing={2} flex={1}>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>
            <FormControl sx={{ flex: 1, width: isDesktop ? "50%" : "100%" }}>
              <Controller
                control={control}
                name="microServiceName"
                render={({ field, fieldState }) => {
                  return (
                    <Autocomplete
                      id="microServiceName"
                      options={microServiceOptions}
                      getOptionLabel={(option) => option.label}
                      value={field.value ? microServiceOptions.find(option => option.value === field.value) : null}
                      onChange={(event, selectedValue) => {
                        field.onChange(selectedValue ? selectedValue.value : '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="MicroService"
                          error={!!fieldState.error}
                        />
                      )}
                    />
                  );
                }}
              />
            </FormControl>
            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>

              <InputControl
                size="medium"
                sx={{ flex: 1, width: "100%" }}
                id="controllerName"
                label="Controller"
                control={control}
              />

            </Box>
          </Stack>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>

            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>
              <InputControl
                size="medium"
                sx={{ flex: 1, width: "100%" }}
                id="actionName"
                label="Action"
                control={control}
              />
            </Box>
            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>
              <SwitchControl
                defaultValue={false}
                label="Yetki"
                control={control}
                id="canCall"
              />
            </Box>
          </Stack>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>


            <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%", }}>
              {roleList && (
                <Controller

                  control={control}
                  name="roleId"
                  render={({
                    field: { onChange, value },
                    fieldState: { error, invalid },
                  }) => {
                    return (
                      <Autocomplete
                        multiple
                        id="roleId"
                        disabled={serviceManagement && serviceManagement?.id > 0}
                        onChange={(event, selectedValue) => {
                          const isSelectAllOptionSelected = selectedValue.some(value => value.value === "all");

                          if (isSelectAllOptionSelected) {
                            if (selectAll) {
                              // "Hepsini Seç" tekrar tıklandı, tüm seçimleri kaldır
                              setSelectedRoleIds([]);
                              setSelectedRoleIdsObject([]);
                              setSelectAll(false);
                              onChange([]); // Form kontrolü için boş dizi gönder
                            } else {
                              // "Hepsini Seç" ilk kez tıklandı, tüm rolleri seç
                              const newSelectedValues = roleList.filter(role => role.value !== "all");
                              const newSelectedRoleIds = newSelectedValues.map(role => Number(role.value));

                              setSelectedRoleIds(newSelectedRoleIds);
                              setSelectedRoleIdsObject(newSelectedValues);
                              setSelectAll(true);
                              onChange(newSelectedRoleIds);
                            }
                          } else {
                            // Normal rollerden seçim yapılıyor
                            const selectedRoleIds = selectedValue.map(value =>
                              typeof value === 'object' ? Number(value.value) : value
                            );

                            setSelectedRoleIds(selectedRoleIds);
                            setSelectedRoleIdsObject(selectedValue);
                            setSelectAll(false);
                            onChange(selectedRoleIds);
                          }
                        }}


                        ListboxProps={{
                          style: { maxHeight: '400px', overflow: 'auto' }
                        }}
                        value={selectedRoleIdsObject}
                        options={roleList}
                        disableCloseOnSelect
                        getOptionLabel={(option: {
                          label: string;
                          value: string;
                        }) => option.label}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={option.value === "all" ? selectAll : selected}
                              value={option.value}
                            />
                            {option.label}
                          </li>
                        )}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Rol"
                            placeholder=""
                            error={invalid}
                            sx={{
                              '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
                                maxHeight: '200px',
                                overflowY: 'auto',
                              },
                              '& .MuiOutlinedInput-input': {
                                maxHeight: '200px',
                                overflowY: 'auto'
                              },

                            }}
                          />
                        )}
                      />
                    );
                  }}
                />
              )}
            </FormControl>
          </Stack>
        </Stack>
        {/* !!! --- Button --- !!! */}
        <Stack justifyContent="flex-end" alignItems="center" direction="row">
          <Button
            variant="contained"
            text={serviceManagement ? "Güncelle" : "Ekle"}
            onClick={handleSubmit(onSubmit)}
          />
        </Stack>
      </Stack>
    </BaseModal>
  );
};
